"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePanoramas = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const maps_api_1 = require("maps-api");
const map_1 = require("../../../map");
const ApiState_1 = require("../../ApiState");
const Auth_1 = require("../../Auth");
const react_1 = require("react");
const usePanoramas = (load = true) => {
    const { activeLau } = (0, Auth_1.useAuth)();
    const [state] = (0, ApiState_1.useApiStateEffect)(async () => {
        if (!load)
            return { panoramas: [] };
        return {
            panoramas: await (0, map_1.getPanoramaList)(activeLau?.id)
        };
    }, [load]);
    const { open, setList } = (0, maps_api_1.usePanorama)();
    (0, react_1.useEffect)(() => {
        if (!state.data)
            return;
        setList(state.data.panoramas);
    }, [state.data, state.data?.panoramas.length]);
    const addToMap = (map, data) => {
        const layer = map.createClusterLayer((count) => {
            return (0, jsx_runtime_1.jsx)(map_1.PanoramaClusterMarker, { count: count });
        }, {
            radius: 100,
            useAverageLocation: false
        });
        const objects = data.panoramas.map((panorama) => {
            const marker = map
                .createMarker(panorama.location, (marker, map) => {
                return ((0, jsx_runtime_1.jsx)(map_1.PanoramaMarker, { interactive: true, onClick: () => {
                        open(panorama.url);
                    } }));
            })
                .initialize();
            return marker;
        });
        layer.add(objects);
        layer.initialize();
        layer.setActive(false);
        return {
            panoramasLayer: layer,
            panoramaMarkers: objects
        };
    };
    return {
        state,
        add: addToMap
    };
};
exports.usePanoramas = usePanoramas;
